import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursor3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cursor-3, arrow"><path d="M5.75833 2.8366C3.92462 2.10814 2.10814 3.92462 2.8366 5.75833L7.96079 18.6572C8.558 20.1605 10.499 20.5613 11.6428 19.4175L12.7498 18.3105L16.0124 21.573C16.6958 22.2565 17.8038 22.2565 18.4873 21.573L21.573 18.4873C22.2565 17.8038 22.2565 16.6958 21.573 16.0124L18.3105 12.7498L19.4175 11.6428C20.5613 10.499 20.1605 8.558 18.6572 7.96079L5.75833 2.8366Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCursor3;
